import React from 'react';
import { makeStyles } from '@material-ui/core';
import { BRAND } from 'theme';
import { SUN } from './illustrations/palette';

interface IProps {
  /** Положение метки задаёт карточка. */
  className: string;
  /** Для тёмного фона: белая метка, как кнопка «Открыть» на карточке дома. */
  onDark?: boolean;
}

const useStyles = makeStyles((theme) => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1.25, 0.5, 1),
    borderRadius: 999,
    color: theme.palette.common.white,
    background: `linear-gradient(135deg, ${BRAND.accent} 0%, #4D8DFF 100%)`,
    boxShadow: '0 4px 12px rgba(0, 94, 255, 0.3)',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '14px',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
  },
  dark: {
    color: BRAND.ink,
    background: theme.palette.common.white,
    boxShadow: '0 4px 12px rgba(26, 26, 81, 0.25)',
  },
  sparkle: {
    width: 10,
    height: 10,
    fill: SUN,
  },
  sparkleDark: {
    fill: BRAND.accent,
  },
}));

/** Метка «New» в углу карточки главной. */
const NewBadge = ({ className, onDark }: IProps) => {
  const classes = useStyles();

  return (
    <span className={`${classes.badge} ${onDark ? classes.dark : ''} ${className}`}>
      <svg
        className={`${classes.sparkle} ${onDark ? classes.sparkleDark : ''}`}
        viewBox="0 0 12 12"
        aria-hidden="true"
      >
        <path d="M6 0l1.4 4.6L12 6l-4.6 1.4L6 12 4.6 7.4 0 6l4.6-1.4z" />
      </svg>
      New
    </span>
  );
};

export default NewBadge;
